import { type AttachmentFileAttributes, AttachmentFileType } from 'owa-attachment-file-types';

/**
 * Wraps a locally opened File (e.g. a saved .eml/.msg) as a compose attachment so
 * it can be attached by value. Used by the "Forward as attachment" flows for
 * locally parsed file messages, whose synthetic item id cannot be attached as a
 * server item reference.
 */
export default function createLocalFileAttachment(file: File): AttachmentFileAttributes[] {
    return [
        {
            file: {
                fileType: AttachmentFileType.Local,
                name: file.name,
                size: file.size,
                type: file.type,
                fileObject: file,
            },
            isInline: false,
        },
    ];
}
